
import XDialog from 'vux/src/components/x-dialog/index.vue'

export default{
components: {
XDialog
},
props: {
name: String,
idCard: String
},
data() {
return {
show: false
}
},
methods: {
hideSelf() {
this.show = false
},
modifyBtnClick() {
this.$emit('onModifyBtnClick');
this.hideSelf();
},
sureBtnClick() {
this.$emit('onSureBtnClick');
this.hideSelf();
}
}
}



// WEBPACK FOOTER //
// ./src/components/views/common/xy-realName-confirm.vue